// extracted by mini-css-extract-plugin
export default {"img":"Logo_img__CzuX8"};